import { render, staticRenderFns } from "./InitialSetupDialog.vue?vue&type=template&id=1f240158&"
import script from "./InitialSetupDialog.vue?vue&type=script&lang=js&"
export * from "./InitialSetupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports